'use client';

import { useTranslation } from 'next-i18next';
import Link from 'next/link';

/**
 * @description Renders a link to the offer page for purchasing Search&View packs
 */
export const SearchpackButton = () => {
  const { t } = useTranslation('common');

  return (
    <div className="flex items-center gap-2">
      <Link
        href="/company/offer"
        target="_blank"
        className="flex gap-2 text-left text-sm text-info hover:underline"
        aria-label={t('my-jobs.card.actions.searchpack')}
      >
        {t('my-jobs.card.actions.searchpack')}
      </Link>
    </div>
  );
};
